module.exports = __webpack_public_path__ + "img/H1.14fb595c.png";